
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4500afbc!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ConfigRoles.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfigRoles.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4500afbc!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfigRoles.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/user/ConfigRoles.vue
// module id = 1020
// module chunks = 2